import styles from './StatusIndicator.module.css';

export type IndicatorState = 'ok' | 'busy' | 'ringing' | 'off';

const LABELS: Record<IndicatorState, string> = {
  ok: 'In Ordnung',
  busy: 'Gestört',
  ringing: 'Klingelt',
  off: 'Aus',
};

export interface StatusIndicatorProps {
  state: IndicatorState;
  /** Überschreibt den Standardtext; Zustand wird immer als Text angezeigt, nie nur über Farbe. */
  label?: string;
}

export function StatusIndicator({ state, label }: StatusIndicatorProps) {
  return (
    <span className={styles.indicator}>
      <span className={`${styles.mark} ${styles[state]}`} aria-hidden="true" />
      {label ?? LABELS[state]}
    </span>
  );
}
